import {connect} from 'react-redux';
import Fees from "./fees";

export default connect()(Fees)
